import createExploreInfiniteTable from './ExploreInfiniteTable';
import { queryFnInfiniteScroll } from 'utils/hooks/useInstagramData';
import useInstagramWeeks from 'utils/hooks/useInstagramWeeks';

// Instagram's rows are not week-scoped, hence no `sendPeriod`: the query
// runs before a period resolves.
const ExploreInstagramHashtagsTable = createExploreInfiniteTable({
    queryName: 'InstagramData',
    queryFn: queryFnInfiniteScroll,
    usePeriod: useInstagramWeeks,
    descendants: true,
    priceSegmentation: true,
    clusterFilterKey: 'instagramCluster',
    clusterPrefix: 'instagram ',
    healthStatKeys: {
        'average weekly likes': 'hs_non_cum_avg_weekly_likes',
        'ig posts': 'hs_likes',
    },
});

export default ExploreInstagramHashtagsTable;
